/* =============================================================
   NFT redemption dApp configuration
   =============================================================
   Live on WAX mainnet. Users send eligible NFTs to CONTRACT_ACCOUNT,
   which credits claimable KEK and burns the NFTs. Only change
   CONTRACT_ACCOUNT if the contract is redeployed to a new account.
   ============================================================= */

// Deployed & configured nft4token contract account (WAX mainnet).
export const CONTRACT_ACCOUNT = 'nftxchange11';

// WAX mainnet chain (same config used by the previous wallet integration)
export const CHAIN = {
  id: '1064487b3cd1a897ce03ae5b6a865651747e2e152090f99c1d19d44e01aea5a4',
  url: 'https://wax.greymass.com',
};

// Official AtomicAssets API (WAX mainnet)
export const ATOMIC_API = 'https://wax.api.atomicassets.io';

// AtomicAssets collection + templates eligible for redemption
export const COLLECTION = 'skekofficial';
export const TEMPLATE_IDS = [893978, 893977, 893976, 893975, 893974, 893972];

// Reward token: contract `waxpepetoken`, symbol KEK, precision 4 (on-chain: "4,KEK")
export const REWARD_TOKEN_CONTRACT = 'waxpepetoken';
export const REWARD_SYMBOL_CODE = 'KEK';
export const REWARD_PRECISION = 4;

// Memo sent with the AtomicAssets transfer (contract ignores memo contents)
export const REDEEM_MEMO = 'claim rewards';

// Wallet login modal branding
export const APP_NAME = 'kek-redeem';
